module.exports = __webpack_public_path__ + "static/category-hero-73ee7de2c0c4f96e5f4ffb66b334a7f2.svg";